import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { CalloutBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Callout.module.css';
interface CalloutProps {
  block: CalloutBlock;
  blockId: string;
}
const TONE_TO_CLASS = {
  info: styles.info,
  warning: styles.warning,
  tip: styles.tip,
  success: styles.success
} as const;
export function Callout(t0) {
  const $ = _c(11);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.body || $[1] !== block.title) {
    t1 = block.title ? <div className={styles.body}><RichSegments segments={block.body} /></div> : <p className={styles.body}><RichSegments segments={block.body} /></p>;
    $[0] = block.body;
    $[1] = block.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const body = t1;
  const t2 = `${styles.callout} ${TONE_TO_CLASS[block.tone]}`;
  let t3;
  if ($[3] !== block.title) {
    t3 = block.title ? <p className={styles.title}>{block.title}</p> : null;
    $[3] = block.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== block.tone || $[6] !== blockId || $[7] !== body || $[8] !== t2 || $[9] !== t3) {
    t4 = <aside className={t2} role="note" data-cms-block-id={blockId} data-cms-field="callout" data-tone={block.tone}>{t3}{body}</aside>;
    $[5] = block.tone;
    $[6] = blockId;
    $[7] = body;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}